import { StateService, UrlService } from "angular-ui-router";
import { HardReloadService } from "../../core/router/hard-reload.service";
import { RouteDeclaration, RouterHelper } from "../../core/router/router-helper.provider";
import { SiteModuleService } from "../../core/services";

/**
 * Load routes valid for the MVC app and register them with the router.
 * @param routerHelper The router helper service.
 * @param siteModuleService The service containing methods to load app states.
 */
export function configureMvcRoutes(routerHelper: RouterHelper, siteModuleService: SiteModuleService,
    hardReloadService: HardReloadService, $urlService: UrlService, $state: StateService) {
    'ngInject'
    siteModuleService.retrieveAppStates()
        .then(routes => {
            const existing = new Set(Array.from($state.get()).map(p => p.name));
            // Set up explicit routes for pages that have not been configured for SPA support yet.
            // Ignore the other routes since they will be configured elsewhere.
            let mvcRoutes: RouteDeclaration[] = routes.filter(p => !p.SupportsSpa && !existing.has(p.StateName))
                .map(p => ({
                    state: `${p.StateName}`,
                    config: {
                        template: `<h1>${p.DisplayName}<h1>`,
                        url: `^/${p.Url}/:id`,
                        params: {
                            requireReload: true,
                            id: { squash: true, value: null }
                        },
                        data: {
                            isMvc: true,
                            permissionKey: p.PermissionKey
                        }
                    }
                }));
            const parentRoutes: Set<string> = new Set();
            for (const mvcRoute of mvcRoutes) {
                const [controller] = mvcRoute.state.split(".");
                if (!existing.has(controller)) {
                    parentRoutes.add(controller);
                }
            }
            // Add route variants for the controller-level route. The top-level
            // route should redirect to the index action, if available.
            mvcRoutes = Array.from(parentRoutes).map<RouteDeclaration>(p => ({
                state: p,
                config: {
                    url: "^/",
                    abstract: true
                }
            })).concat(mvcRoutes);
            const states = mvcRoutes;
            // Don't declare the otherwise route until the MVC routes have all loaded.
            routerHelper.configureStates(states, "/404");
        })
        .then(() => hardReloadService.init())
        .then(function () {
            // UI Router will initially set the $state to the default ^ route since
            // the routes will not be defined when performing the initial match.
            // Work around this by transitioning to the same page state and back.
            const url = window.location.pathname;
            const state = ($urlService.match({ path: url }).rule as any).state;
            const query = window.location.search.replace(/^\?/, "")
                .split("&")
                .map(p => p.split("="))
                .reduce((query, [field, value]) => {
                    query[field] = decodeURIComponent(value);
                    return query;
                }, {})
            if (state && state.data && state.data.isMvc) {
                return $state.go(state, { requireReload: false, ...query }, { supercede: false });
            } else if (!state) {
                return $state.go("404");
            }
        });
}
